import React from "react";

function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      fill="none"
      viewBox="0 0 46 46"
    >
      <rect width="40" height="40" x="3" y="3" fill="#F7FAFC" rx="20"></rect>
      <rect
        width="40"
        height="40"
        x="3"
        y="3"
        stroke="#F7FAFC"
        strokeWidth="6"
        rx="20"
      ></rect>
      <path
        stroke="#5D6B7F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M19.667 26.333L23 23m0 0l3.333 3.333M23 23v7.5m6.667-3.548a4.583 4.583 0 00-2.917-8.12.516.516 0 01-.445-.25 6.25 6.25 0 10-9.816 7.58"
      ></path>
    </svg>
  );
}

export default UploadIcon;